import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

const TableHeader = ({
  columns,
  sortConfig,
  onSort,
  className = '',
}) => {
  // Get sort direction for a column
  const getSortDirection = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction;
    }
    return null;
  };

  return (
    <thead className={`bg-gray-50 ${className}`}>
      <tr>
        {columns.map(column => (
          <th
            key={column.id}
            scope="col"
            className={`px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider ${
              column.sortable ? 'cursor-pointer' : ''
            } ${column.align === 'right' ? 'text-right' : 'text-left'}`}
            onClick={() => column.sortable && onSort(column.id)}
          >
            <div className={`flex items-center ${column.align === 'right' ? 'justify-end' : ''}`}>
              {column.name}
              {column.sortable && (
                <>
                  {getSortDirection(column.id) === 'asc' && <ArrowUp size={14} className="ml-1" />}
                  {getSortDirection(column.id) === 'desc' && <ArrowDown size={14} className="ml-1" />}
                </>
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader; 